<template>
  <div :class="[{opened: isOpened}, 'unit-dictionary-window']">
    <div class="scroll-view">
      <div class="close" v-on:click="close">&times;</div>
      <div class="inner">
        <h1>Achievement</h1>
        <div class="achievements">
          <div v-if="achievements.length > 0">
            <div v-for="achievement in achievements" :key="'achievement-' + achievement.uid" class="achievement">
              <strong>{{achievement.title}}</strong> <div>{{achievement.body}}</div>
            </div>
          </div>
          <div v-else class="nothing-achivement">
            まだ達成したアチーブメントはありません。
          </div>
        </div>
        <h1>植物図鑑</h1>
        <div class="discovered-units">
          <div v-for="speciesInfo in species" :key="`dictionary-${speciesInfo.type}-${speciesInfo.name}`" class="speciesInfo">
            <h2>{{speciesInfo.label}}</h2>

            <div class="unit-templates">
              <div class="adult-tree">
                <div v-if='gotTemplates.includes(`${speciesInfo.type}_${speciesInfo.name}_adult`)'>
                  <img :src="require(`@/assets/img/units/${speciesInfo.type}_${speciesInfo.name}_adult/default.png`)" />
                </div>
                <div v-else class="undiscovered-unit">
                  <img :src="`/static/img/undiscovered.png`" />
                </div>
              </div>
              <div class="tree-description">
                <div class="unit-sizes">
                  <div v-for="(unitTemplate, i) in speciesInfo.sizes" :key="`dictionary-${speciesInfo.type}-${speciesInfo.name}-${i}`" class="unit-size">
                    <div v-if="i === 'adult'" />
                    <div v-else-if='gotTemplates.includes(unitTemplate.type)' class="discovered-unit">
                      <img :src="require(`@/assets/img/units/${unitTemplate.type}/default.png`)" />
                    </div>
                    <div v-else class="undiscovered-unit">
                      <img :src="`/static/img/undiscovered.png`" />
                    </div>
                  </div>
                </div>
                <div class="adult-tree-description" v-if='gotTemplates.includes(`${speciesInfo.type}_${speciesInfo.name}_adult`)'>
                  {{speciesInfo.sizes.adult.description}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import unitTemplates from '@/lib/unit_templates';

export default {
  name: 'UnitDictionary',
  methods: {
    close() {
      this.$store.dispatch('setUserActionMode', { mode: null });
    },
  },
  computed: {
    isOpened() {
      return this.$store.state.userActionMode === 'unit-dictionary';
    },
    gotTemplates() {
      return this.$store.state.game.unitManager.dictionary;
    },
    unitTemplates() {
      return unitTemplates.filter(t => {
        return (
          t.categories.includes('tree-seed') || t.categories.includes('tree')
        );
      });
    },
    species() {
      // TODO: かなり微妙なのでいつか修正する (UnitTemplate に種の情報を追記して、それを利用する)
      return unitTemplates.reduce(
        (acc, t) => {
          if (
            !t.categories.includes('tree-seed') &&
            !t.categories.includes('tree')
          )
            return acc;

          const [type, name, size] = t.type.split('_');
          const i = acc.findIndex(t => t.type == type && t.name == name);

          if (i !== -1) {
            acc[i].sizes[size] = t;
          }

          return acc;
        },
        [
          {
            label: 'ブナ',
            type: 'd',
            name: 'tree1',
            sizes: {
              seed: null,
              sprout: null,
              child: null,
              young: null,
              adult: null,
            },
          },
          {
            label: 'スギ',
            type: 'd',
            name: 'tree2',
            sizes: {
              seed: null,
              sprout: null,
              child: null,
              young: null,
              adult: null,
            },
          },
          {
            label: 'イタヤカエデ',
            type: 'd',
            name: 'tree3',
            sizes: {
              seed: null,
              sprout: null,
              child: null,
              young: null,
              adult: null,
            },
          },
          {
            label: 'ケヤキ',
            type: 's',
            name: 'tree1',
            sizes: {
              seed: null,
              sprout: null,
              child: null,
              young: null,
              adult: null,
            },
          },
          {
            label: 'クリ',
            type: 's',
            name: 'tree2',
            sizes: {
              seed: null,
              sprout: null,
              child: null,
              young: null,
              adult: null,
            },
          },
          {
            label: 'ヤマザクラ',
            type: 's',
            name: 'tree3',
            sizes: {
              seed: null,
              sprout: null,
              child: null,
              young: null,
              adult: null,
            },
          },
        ]
      );
    },
    achievements() {
      return this.$store.state.game.achievements;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.unit-dictionary-window {
  position: absolute;
  color: #fff;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 6px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  display: none;
  animation: fadeIn 0.5s;
  padding: 80px 0 20px;

  .scroll-view {
    height: 100%;
    overflow-y: scroll;
  }

  &.opened {
    display: block;
  }

  .inner {
    padding: 2em 5em;
  }

  .discovered-units {
    .speciesInfo {
      margin-bottom: 4rem;
      font-size: 1rem;
      line-height: 1.8em;

      .unit-templates {
        // TODO: autoprefixer 対応
        display: -ms-grid;
        -ms-grid-columns: 150px 1fr;
        -ms-grid-rows: 1fr;

        display: grid;
        grid-template-columns: 150px 1fr;
        grid-template-rows: 1fr;
      }

      .adult-tree {
        // TODO: autoprefixer 対応
        -ms-grid-row: 1/3;
        -ms-grid-column: 1;

        grid-row: 1/3;
        grid-column: 1;
        margin-right: 0.5rem;

        img {
          width: 100%;
          display: block;
          background: #333;
          border-radius: 3px;
        }
      }

      .tree-description {
        // TODO: autoprefixer 対応
        -ms-grid-row: 1;
        -ms-grid-column: 2;

        grid-row: 1;
        grid-column: 2;
        text-align: left;
      }

      .unit-sizes {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        margin-bottom: 0.2rem;

        img {
          margin-right: 5px;
          width: 50px;
          background: #333;
          border-radius: 3px;
        }
      }
    }
  }

  .achievements {
    margin-bottom: 4rem;

    .achievement {
      margin-bottom: 2rem;
    }
  }

  .close {
    position: absolute;
    top: 0;
    left: 0;
    $size: 80px;
    font-size: $size;
    line-height: $size;
    height: $size;
    width: $size;
    padding: 0;
    cursor: pointer;
    transition: opacity 0.1s;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/UnitDictionary.vue